/** Key value for share status between modules while fetching */
export enum FetchStatus {
  IDLE = 0,
  FETCHING = 1,
  SUCCESS = 2,
  ERROR = 3,
}

/** Key value for sharing custom error code between components */
export const CUSTOM_ERROR_INFO = {
  UNABLE_PAGE_RENDER: {
    errorCode: 'OM_XXX_OPPR00001',
    errorDescription: 'Unable to find page to render',
  },
  UNABLE_FETCH_CMS: {
    errorCode: 'OM_XXX_OPFC00001',
    errorDescription: 'Unable to fetch content from CMS',
  },
} as const

export const FIRMWARE_UPDATE_OPTIONS = {
  AUTO: 'auto',
  NOTIFY: 'notify',
} as const

export type FirmwareUpdateOptionType =
  (typeof FIRMWARE_UPDATE_OPTIONS)[keyof typeof FIRMWARE_UPDATE_OPTIONS]

export const SUPPLY_TYPES = {
  INK: 'ink',
  LASER: 'laser',
} as const

export type SupplyType = (typeof SUPPLY_TYPES)[keyof typeof SUPPLY_TYPES]

export const CARTRIDGE_TYPES = {
  DEFAULT: 'default',
  CIRCUITRY: 'circuitry',
  CHIP: 'chip',
} as const

export type CartridgeType =
  (typeof CARTRIDGE_TYPES)[keyof typeof CARTRIDGE_TYPES]

export const RESOURCE_FETCHING_STATUS = {
  TRUNCATED: 'truncated',
  SUCCESS: 'success',
  UNAVAILABLE: 'unavailable',
} as const

export type ResourceFetchingStatus =
  (typeof RESOURCE_FETCHING_STATUS)[keyof typeof RESOURCE_FETCHING_STATUS]

export const RESOURCE_FETCHING_STATUS_KEY = {
  ACTION_PRINT_ENGINE_SETUP: 'actionPrintEngineSetupResult',
  MEDIA_INPUTS: 'mediaInputsResult',
  SUPPLIES: 'suppliesResult',
  CALIBRATIONS: 'calibrationsResult',
} as const

export type ResourceFetchingStatusKey =
  (typeof RESOURCE_FETCHING_STATUS_KEY)[keyof typeof RESOURCE_FETCHING_STATUS_KEY]

export const RESOURCE_RESULTS_KEY = {
  ACTION_PRINT_ENGINE_SETUP: 'actionPrintEngineSetup',
  MEDIA_INPUTS: 'mediaInputs',
  SUPPLIES: 'supplies',
  CALIBRATIONS: 'calibrations',
} as const

export type ResourceResultsKey =
  (typeof RESOURCE_RESULTS_KEY)[keyof typeof RESOURCE_RESULTS_KEY]

export const PRINTER_FUNCTION_TYPE = {
  MFP: 'MFP',
  SFP: 'SFP',
} as const

export type PrinterFunctionType =
  (typeof PRINTER_FUNCTION_TYPE)[keyof typeof PRINTER_FUNCTION_TYPE]

export const SCAN_SETUP_COOKIES = 'scanSetupComplete'
export const NEW_PRINTER_ADD_COOKIES = 'newPrinterAdded'

export const LASER_IO_REF = { DEFAULT: '76010', CHIP: '76005' } as const
export type LaserIoRefCode = (typeof LASER_IO_REF)[keyof typeof LASER_IO_REF]
